'use client'

import { clsx } from 'clsx'
import { useSearchParams } from 'next/navigation'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconClose } from '@redteclab/icons'

import { Button, FormControl, FormLabel, Input } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetSearchPage } from '../../../../url-handling'

type SearchPageNoResultNewSearchFormProps = {
  className?: string
}

export const SearchPageNoResultNewSearchForm: FC<
  SearchPageNoResultNewSearchFormProps
> = ({ className }) => {
  const searchParams = useSearchParams()

  const config = useGlobalConfigContext()

  const searchTerm = searchParams.get('query') ?? searchParams.get('q')

  return (
    <div
      className={clsx(
        'flex flex-col items-start gap-6 rounded-2xl bg-light-primary-medium p-6',
        className,
      )}
    >
      <div className="text-m">
        <FormattedMessage
          id="searchResults.empty.noMatchesForQuery_ho"
          values={{
            query: <q>{searchTerm}</q>,
          }}
        />{' '}
        <FormattedMessage id="searchResults.empty.formLabel" />
      </div>

      <form
        action={urlResolverGetSearchPage(config)}
        className="flex w-full flex-col gap-4"
      >
        <FormControl defaultValue={searchTerm}>
          <FormLabel htmlFor="refinements-item-search">
            <FormattedMessage id="general.label.placeholder.search" />
          </FormLabel>
          <Input
            endAdornment={<IconClose className="size-6 fill-dark-brand" />}
            name="q"
          />

          <input
            name="i"
            type="hidden"
            value={searchParams.get('i') ?? undefined}
          />
          <input
            name="searchChannel"
            type="hidden"
            value={searchParams.get('searchChannel') ?? undefined}
          />
          <input
            name="userToken"
            type="hidden"
            value={searchParams.get('userToken') ?? undefined}
          />
        </FormControl>
        <Button size="large" type="submit" variant="filled">
          <FormattedMessage id="general.button.label.search" />
        </Button>
      </form>
    </div>
  )
}
